const { getRandomNumFromMsec, getRandomNumFromDate } = require('../core/rand').default;
const { getStageGimmick, stageGimmick } = require('../core/stageData').default;
const gameParamater = require('../define/gameParamater').default;
const { APP_REBOOT, START_GAME, STAGE_INIT, STAGE_CLEAR, STAGE_CONTINUE, GAME_OVER, GAME_PAUSE, GAME_RESUME, ADD_SCORE, GAME_CLEAR, PLACEMENT_BOX, BREAK_TREASURE } = require("./actions");
// ============================

const initialState = {
    isGamePlaying: false,
    remainingTime: gameParamater.REMAINING_TIME,
    baseTime: undefined,
    startedAt: undefined,
    stoppedAt: undefined,
    score: 0,
    playerName: "",
    isGameClear: false,
    playerCharactor: null,
    arrivalStage: 1,
    continueCount: gameParamater.COUNTINUE_COUNT,
    totalAttack: 0,
    totalDamage: 0,
    totalPlacementPorin: 0,
    totalBreakPorin: 0,
    totalBreakTreasure: 0,
    gimmick: undefined,
    gimmickNo: 0,
    backup: {}
};

const getGimmickNo = gimmick => {
    switch (gimmick) {
        case stageGimmick.GIMMICK_BEAST:
            return getRandomNumFromMsec(3);
        default:
            return 0;
    }
}

export function gameState(state = initialState, action) {
    console.log(`# gameState: ${JSON.stringify(state)} -> ${JSON.stringify(action)}`);
    switch (action.type) {
        case APP_REBOOT:
            return initialState;
        case START_GAME:
            return {
                ...state,
                score: action.score,
                playerName: action.playerName,
                playerCharactor: action.playerCharactor,
                continueCount: action.continueCount,
                arrivalStage: action.arrivalStage,
                totalAttack: action.totalAttack,
                totalDamage: action.totalDamage,
                totalPlacementPorin: action.totalPlacementPorin,
                totalBreakPorin: action.totalBreakPorin,
                totalBreakTreasure: action.totalBreakTreasure,
                backup: {
                    arrivalStage: action.arrivalStage,
                    score: action.score,
                    playerName: action.playerName,
                    playerCharactor: action.playerCharactor,
                    totalBreakTreasure: action.totalBreakTreasure,
                    totalPlacementPorin: action.totalPlacementPorin
                }
            }
        case STAGE_INIT:
            const gimmick = getStageGimmick(action.arrivalStage);
            return {
                ...state,
                isGamePlaying: false,
                remainingTime: gameParamater.REMAINING_TIME,
                arrivalStage: action.arrivalStage,
                baseTime: 0,
                gimmick,
                gimmickNo: getGimmickNo(gimmick),
                startedAt: state.startedAt ? action.now : undefined,
                stoppedAt: state.stoppedAt ? action.now : undefined
            }
        case STAGE_CONTINUE:
            return {
                ...state,
                isGamePlaying: false,
                remainingTime: gameParamater.REMAINING_TIME,
                arrivalStage: action.arrivalStage,
                score: state.backup.score,
                playerName: state.backup.playerName,
                playerCharactor: state.backup.playerCharactor,
                continueCount: state.continueCount - 1,
                totalBreakTreasure: state.backup.totalBreakTreasure,
                totalPlacementPorin: state.backup.totalPlacementPorin,
                baseTime: 0,
                startedAt: state.startedAt ? action.now : undefined,
                stoppedAt: state.stoppedAt ? action.now : undefined
            }
        case STAGE_CLEAR:
            return {
                ...state,
                isGamePlaying: false,
                stoppedAt: action.now,
                continueCount: gameParamater.COUNTINUE_COUNT,
                backup: {
                    arrivalStage: state.arrivalStage,
                    score: state.score,
                    playerName: state.playerName,
                    playerCharactor: state.playerCharactor,
                    totalBreakTreasure: state.totalBreakTreasure,
                    totalPlacementPorin: state.totalPlacementPorin
                }
            }
        case ADD_SCORE:
            return {
                ...state,
                score: state.score + action.score
            }
        case GAME_CLEAR:
            return {
                ...state,
                isGameClear: true,
                isGamePlaying: false,
                stoppedAt: action.now
            }
        case GAME_OVER:
            return {
                ...state,
                isGamePlaying: false,
                stoppedAt: action.now
            }
        case GAME_PAUSE:
            return {
                ...state,
                isGamePlaying: false,
                stoppedAt: action.now
            }
        case GAME_RESUME:
            return {
                ...state,
                isGamePlaying: true,
                baseTime: action.baseTime,
                startedAt: action.now,
                stoppedAt: undefined
            }
        case BREAK_TREASURE:
            return {
                ...state,
                totalBreakTreasure: state.totalBreakTreasure + 1
            }
        case PLACEMENT_BOX:
            return {
                ...state,
                totalPlacementPorin: state.totalPlacementPorin + 1
            }
        default:
            return state;
    }
}